import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { List } from 'foundations-components/transitional/components/List';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { CMS_HUB_ENTERPRISE, CMS_HUB_PROFESSIONAL, COMMERCE_HUB_ENTERPRISE, COMMERCE_HUB_PROFESSIONAL, MARKETING_HUB_ENTERPRISE, MARKETING_HUB_PROFESSIONAL, MARKETING_PLUS_ENTERPRISE_BUNDLE, MARKETING_PLUS_PROFESSIONAL_BUNDLE, OPERATIONS_HUB_ENTERPRISE, OPERATIONS_HUB_PROFESSIONAL, SALES_HUB_ENTERPRISE, SALES_HUB_PROFESSIONAL, SERVICE_HUB_ENTERPRISE, SERVICE_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { ENTERPRISE, PROFESSIONAL } from 'self-service-api/constants/Editions';
import { getHubAndTierFromApiName, isCommerceHub } from '../../../ums/utils';
import { StyledModal } from '../../common/components/StyledModal';
import TrialRedirectButton from '../../common/components/activation/tx-120/TrialRedirectButton';
import { navigateTo } from '../../common/navigation/url';
import { getTrialGuideUrlFromApiName } from '../../utils/links';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Welcome = ({
  apiName
}) => {
  switch (apiName) {
    case CMS_HUB_PROFESSIONAL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.welcome.cms-hub-professional"
      });
    case CMS_HUB_ENTERPRISE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.welcome.cms-hub-enterprise"
      });
    case MARKETING_HUB_PROFESSIONAL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.welcome.marketing-hub-professional"
      });
    case MARKETING_HUB_ENTERPRISE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.welcome.marketing-hub-enterprise"
      });
    case OPERATIONS_HUB_PROFESSIONAL:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.trialActivationModal.welcome.operations-hub-professional'
        });
      }
    case OPERATIONS_HUB_ENTERPRISE:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.trialActivationModal.welcome.operations-hub-enterprise'
        });
      }
    case SALES_HUB_PROFESSIONAL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.welcome.sales-hub-professional"
      });
    case SALES_HUB_ENTERPRISE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.welcome.sales-hub-enterprise"
      });
    case SERVICE_HUB_PROFESSIONAL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.welcome.service-hub-professional"
      });
    case SERVICE_HUB_ENTERPRISE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.welcome.service-hub-enterprise"
      });
    case COMMERCE_HUB_PROFESSIONAL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.welcome.commerce-hub-professional"
      });
    case COMMERCE_HUB_ENTERPRISE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.welcome.commerce-hub-enterprise"
      });
    case MARKETING_PLUS_PROFESSIONAL_BUNDLE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.welcome.marketing-plus-professional-bundle"
      });
    case MARKETING_PLUS_ENTERPRISE_BUNDLE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.welcome.marketing-plus-enterprise-bundle"
      });
    default:
      return null;
  }
};
const ProductFeatures = ({
  apiName
}) => {
  switch (apiName) {
    case CMS_HUB_PROFESSIONAL:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.features.cms-hub-professional"
      }, "cms-hub-professional")];
    case CMS_HUB_ENTERPRISE:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.features.cms-hub-enterprise"
      }, "cms-hub-enterprise")];
    case MARKETING_HUB_PROFESSIONAL:
      {
        return [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.trialActivationModal.features.marketing-hub-professional"
        }, "marketing-hub-professional")];
      }
    case MARKETING_HUB_ENTERPRISE:
      {
        return [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.trialActivationModal.features.marketing-hub-enterprise"
        }, "marketing-hub-enterprise")];
      }
    case OPERATIONS_HUB_PROFESSIONAL:
      {
        return [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.trialActivationModal.features.operations-hub-professional"
        }, "operations-hub-professional")];
      }
    case OPERATIONS_HUB_ENTERPRISE:
      {
        return [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.trialActivationModal.features.operations-hub-enterprise"
        }, "operations-hub-enterprise")];
      }
    case SALES_HUB_PROFESSIONAL:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.features.sales-hub-professional"
      }, "sales-hub-professional")];
    case SALES_HUB_ENTERPRISE:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.features.sales-hub-enterprise"
      }, "sales-hub-enterprise")];
    case SERVICE_HUB_PROFESSIONAL:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.features.service-hub-professional"
      }, "service-hub-professional")];
    case SERVICE_HUB_ENTERPRISE:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.features.service-hub-enterprise"
      }, "service-hub-enterprise")];
    case COMMERCE_HUB_PROFESSIONAL:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.features.commerce-hub-professional"
      }, "commerce-hub-professional")];
    case COMMERCE_HUB_ENTERPRISE:
      return [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.trialActivationModal.features.commerce-hub-enterprise"
      }, "commerce-hub-enterprise")];
    case MARKETING_PLUS_PROFESSIONAL_BUNDLE:
      {
        return [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.trialActivationModal.features.cms-hub-professional"
        }, "cms-hub-professional"), /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.trialActivationModal.features.marketing-hub-professional'
        }, "marketing-hub-professional")];
      }
    case MARKETING_PLUS_ENTERPRISE_BUNDLE:
      {
        return [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.trialActivationModal.features.cms-hub-enterprise"
        }, "cms-hub-enterprise"), /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'upgrades.trialActivationModal.features.marketing-hub-enterprise'
        }, "marketing-hub-enterprise")];
      }
    default:
      return [];
  }
};
export const TrialActivationSuccessModal = ({
  onSuccess = () => {},
  showTrialLoadingState,
  upgradeData,
  upgradeData: {
    upgradeProduct,
    apiName,
    source
  },
  featureData
}) => {
  const {
    tier,
    hub
  } = getHubAndTierFromApiName(apiName || UpgradeProductToApiNameMap[upgradeProduct]);
  const handleRedirectButtonClick = () => {
    if (isCommerceHub(hub)) {
      navigateTo(getTrialGuideUrlFromApiName(apiName || UpgradeProductToApiNameMap[upgradeProduct], source));
    } else {
      onSuccess();
    }
  };
  return /*#__PURE__*/_jsxs(StyledModal, {
    centered: true,
    size: "auto",
    use: "success",
    width: 466,
    "data-test-id": "activation-success-modal",
    children: [/*#__PURE__*/_jsx(DialogHeaderImage, {
      offsetBottom: 10,
      offsetTop: 40,
      children: /*#__PURE__*/_jsx(Illustration, {
        name: featureData !== null && featureData !== void 0 && featureData.displayName && !isCommerceHub(hub) ? 'errors/map' : 'setup-complete',
        width: 118
      })
    }), /*#__PURE__*/_jsx(DialogHeader, {
      marginBlock: "0",
      paddingBlockStart: "0",
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-600",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(Welcome, {
          apiName: apiName
        })
      })
    }), /*#__PURE__*/_jsx(DialogBody, {
      textAlign: "left",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "upgrades.trialActivationModal.featureListHead"
        }), /*#__PURE__*/_jsxs(List, {
          styled: true,
          wrapChildren: true,
          listStylePosition: "outside",
          children: [/*#__PURE__*/_jsx(ProductFeatures, {
            apiName: apiName
          }), tier === PROFESSIONAL && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.trialActivationModal.features.trialGuide"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.trialActivationModal.features.support"
          }), tier === PROFESSIONAL && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.trialActivationModal.features.includesStarter"
          }), tier === ENTERPRISE && /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.trialActivationModal.features.includesProfessional"
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(List, {
        marginBlockEnd: "300",
        children: showTrialLoadingState ? /*#__PURE__*/_jsx(LoadingSpinner, {
          showLabel: true,
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.trialActivationModal.loadingLabel"
          })
        }) : /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "300",
          children: [/*#__PURE__*/_jsx(Text, {
            typography: "body-125",
            children: featureData !== null && featureData !== void 0 && featureData.displayName && !isCommerceHub(hub) ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "upgrades.trialActivationModal.footerWithFeature",
              options: {
                feature: featureData.displayName
              }
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: "upgrades.trialActivationModal.footer"
            })
          }), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "600",
            inlineSize: "170px",
            children: /*#__PURE__*/_jsx(TrialRedirectButton, {
              block: true,
              use: "primary",
              onClick: handleRedirectButtonClick,
              buttonText: featureData !== null && featureData !== void 0 && featureData.displayName ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "upgrades.trialActivationModal.getStarted"
              }) : /*#__PURE__*/_jsx(FormattedMessage, {
                message: "upgrades.trialActivationModal.redirectButton"
              }),
              upgradeData: upgradeData
            })
          })]
        })
      })
    })]
  });
};